import { ArrowRight } from "lucide-react";

export default function Pricing() {
  const scrollToForm = () => {
    const el = document.getElementById("lead-form");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section
      id="prijzen"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="pricing-section"
    >
      <div className="absolute inset-0 opacity-40 pointer-events-none jn-grid-bg" />
      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        <div className="jn-glass rounded-[2rem] p-10 md:p-16 lg:p-20 relative overflow-hidden">
          <div
            className="absolute -top-20 -right-20 w-80 h-80 rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(closest-side, rgba(0,229,255,0.25), transparent)",
            }}
          />
          <div className="relative grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-7">
              <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-5">
                Lanceringsprijs
              </div>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight leading-[1.05]">
                Start met{" "}
                <span className="italic" style={{ color: "#C5A059" }}>
                  Privacy Smart Film.
                </span>
              </h2>
              <p className="mt-6 text-base md:text-lg text-zinc-400 font-body max-w-xl leading-relaxed">
                Onze lanceringsprijs voor Privacy Smart Film start vanaf{" "}
                <span className="text-white font-medium">€199/m²</span>,{" "}
                <span className="text-zinc-300">excl. installatie</span>. Na
                een korte intake bezorgen we een duidelijke prijsinschatting
                op maat.
              </p>
              <div className="mt-5 space-y-2 max-w-xl">
                <p className="text-xs text-zinc-500 font-body italic">
                  Prijs afhankelijk van afmetingen, type glas, toepassing,
                  elektrische aansluiting, installatie en gekozen oplossing.
                </p>
                <p className="text-xs text-zinc-500 font-body">
                  Voeding/controller en installatie worden apart berekend.
                </p>
                <p
                  className="mt-3 text-[11px] uppercase tracking-[0.2em] inline-block px-3 py-1.5 rounded-full border"
                  style={{
                    color: "#C5A059",
                    borderColor: "rgba(197,160,89,0.4)",
                    background: "rgba(197,160,89,0.06)",
                  }}
                  data-testid="b2b-pricing-note"
                >
                  LED / Display Film: prijs op aanvraag voor B2B-projecten.
                </p>
              </div>
            </div>

            <div className="lg:col-span-5 flex flex-col items-start lg:items-end gap-6">
              <div className="flex items-baseline gap-2">
                <span className="text-xs uppercase tracking-[0.25em] text-zinc-500">
                  Vanaf
                </span>
                <span
                  className="font-heading font-light text-white"
                  style={{ fontSize: "clamp(4rem, 10vw, 8rem)", lineHeight: 1 }}
                  data-testid="pricing-amount"
                >
                  €199
                </span>
                <span className="text-sm text-zinc-400 font-body">/m²</span>
              </div>
              <p className="text-xs text-zinc-500 font-body lg:text-right -mt-3">
                excl. installatie
              </p>
              <button
                onClick={scrollToForm}
                className="jn-btn-primary inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm md:text-base"
                data-testid="pricing-cta"
              >
                Vraag je prijsinschatting aan
                <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
